export default __webpack_public_path__ + "assets/russia-flag.png";